<script lang="ts">
    import Button from "./Button.svelte";
    import Icon from "./Icon.svelte";
    export let class_list = [];
    export let icon = "search";
    export let side = "right"; //right, center or left
</script>

<div
    class="fixed-action-btn
{side == 'center' ? 'FAB_centered' : ''}
{side ==
    'left'
        ? 'FAB_left'
        : ''}
"
>
    <Button class_list={class_list} on:click size="large" floating={true}>
        <Icon icon="{icon}" />
    </Button>
</div>

<style>
    .FAB_centered {
        right: auto;
        left:45%;
    }
    .FAB_left {
        right:auto;
        left: 23px;
    }
</style>
